import { defaultTranslations } from '../constants/defaultTranslations_simplified-registration-BrandPartner';
import type { IFormattedMessageProps } from '../interfaces';
import { TranslationKey } from '../models';

export const getErrorLocalizationByCode = (errorCode?: string, fieldName?: string): IFormattedMessageProps => {
  switch (errorCode) {
    case '105':
      return { defaultMessage: defaultTranslations.validationRequired, id: TranslationKey.validationRequired };
    case '119':
      return { defaultMessage: defaultTranslations.validationLength, id: TranslationKey.validationLength };
    case '106':
      switch (fieldName) {
        case 'contactEmail':
          return { defaultMessage: defaultTranslations.validationRegexEmail, id: TranslationKey.validationRegexEmail };
        case 'contactTelephone':
          return { defaultMessage: defaultTranslations.validationRegexPhone, id: TranslationKey.validationRegexPhone };
        case 'uniqueId':
          return {
            defaultMessage: defaultTranslations.validationRegexUniqueID,
            id: TranslationKey.validationRegexUniqueID,
          };
        case 'birthDate':
          return {
            defaultMessage: defaultTranslations.validationRegexBirthDate,
            id: TranslationKey.validationRegexBirthDate,
          };
        case 'identityCard.expiration':
          return {
            defaultMessage: defaultTranslations.validationRegexIdentityCardDateExpiration,
            id: TranslationKey.validationRegexIdentityCardDateExpiration,
          };
        default:
          return { defaultMessage: defaultTranslations.validationRegex, id: TranslationKey.validationRegex };
      }
    case '108':
      return {
        defaultMessage: defaultTranslations.validationEmailIsAlreadyUsed,
        id: TranslationKey.validationEmailIsAlreadyUsed,
      };
    case '109':
      return { defaultMessage: defaultTranslations.validationUniquePhone, id: TranslationKey.validationUniquePhone };
    case '110':
      return {
        defaultMessage: defaultTranslations.validationUniqueUniqueId,
        id: TranslationKey.validationUniqueUniqueId,
      };
    case '117':
      return {
        defaultMessage: defaultTranslations.validationValidUniqueId,
        id: TranslationKey.validationValidUniqueId,
      };
    case '121':
      return {
        defaultMessage: defaultTranslations.validationEmailTerminatedCustomer,
        id: TranslationKey.validationEmailTerminatedCustomer,
      };
    case '128':
      return {
        defaultMessage: defaultTranslations.validationUniqueBankAccount,
        id: TranslationKey.validationUniqueBankAccount,
      };
    case '134':
      return {
        defaultMessage: defaultTranslations.validationXmlCharacters,
        id: TranslationKey.validationXmlCharacters,
      };
    case '137':
      return { defaultMessage: defaultTranslations.fileTypeIsNotSupported, id: TranslationKey.fileTypeIsNotSupported };
    case '139':
      return {
        defaultMessage: defaultTranslations.validationValidConfirmationCode,
        id: TranslationKey.validationValidConfirmationCode,
      };
    case '141':
      return {
        defaultMessage: defaultTranslations.validationMandatoryPropertyIsNull,
        id: TranslationKey.validationMandatoryPropertyIsNull,
      };
    case '149':
      return {
        defaultMessage: defaultTranslations.validationUniqueCustomerAttribute,
        id: TranslationKey.validationUniqueCustomerAttribute,
      };
    case '151':
      return {
        defaultMessage: defaultTranslations.validationUniqueTaxCode,
        id: TranslationKey.validationUniqueTaxCode,
      };
    case '152':
      return {
        defaultMessage: defaultTranslations.validationUniqueTaxCode2,
        id: TranslationKey.validationUniqueTaxCode2,
      };
    case '155':
      return { defaultMessage: defaultTranslations.validationUniqueAlias, id: TranslationKey.validationUniqueAlias };
    case '156':
      return {
        defaultMessage: defaultTranslations.validationUniqueDisplayName,
        id: TranslationKey.validationUniqueDisplayName,
      };
    case '153':
      return { defaultMessage: defaultTranslations.validationValidPhone, id: TranslationKey.validationValidPhone };
    case '244':
      return {
        defaultMessage: defaultTranslations.birthDate_LegalRequirementsFailed,
        id: TranslationKey.birthDate_LegalRequirementsFailed,
      };
    case '403':
      return {
        defaultMessage: defaultTranslations.document_ExpirationTooSoon,
        id: TranslationKey.document_ExpirationTooSoon,
      };
    case '111':
      return {
        defaultMessage: defaultTranslations.birthDate_DoesntMatchUniqueId,
        id: TranslationKey.birthDate_DoesntMatchUniqueId,
      };
    case '118':
      return { defaultMessage: defaultTranslations.birthDate_OutOfRange, id: TranslationKey.birthDate_OutOfRange };
    case '148':
      return {
        defaultMessage: defaultTranslations.termsAndConditions_Mandatory,
        id: TranslationKey.termsAndConditions_Mandatory,
      };
    case '104':
      return { defaultMessage: defaultTranslations.customer_NotUnique, id: TranslationKey.customer_NotUnique };
    case '169':
      return { defaultMessage: defaultTranslations.customer_NotEligible, id: TranslationKey.customer_NotEligible };
    case '115':
      return {
        defaultMessage: defaultTranslations.validationValidSponsorNumber,
        id: TranslationKey.validationValidSponsorNumber,
      };
    case '179':
      return {
        defaultMessage: defaultTranslations.Prestep_ExternalAccountAlreadyConnected,
        id: TranslationKey.Prestep_ExternalAccountAlreadyConnected,
      };
    case '299':
      return {
        defaultMessage: defaultTranslations.Prestep_UnauthorizedAccess,
        id: TranslationKey.Prestep_UnauthorizedAccess,
      };
    case '428':
      return {
        defaultMessage: defaultTranslations.Prestep_InvitationCodeNotFound,
        id: TranslationKey.Prestep_InvitationCodeNotFound,
      };
    case '324':
      return {
        defaultMessage: defaultTranslations.Prestep_RegistrationFailed,
        id: TranslationKey.Prestep_RegistrationFailed,
      };
    default:
      return { defaultMessage: defaultTranslations.errorOccured, id: TranslationKey.errorOccured };
  }
};
